module.exports = __webpack_public_path__ + "static/media/MICHELL TECNOARM 2 TONEARM.1df5b33b.png";